<template>
  <div class="footer">
    <div class="foot">
      <div class="foot-inner">
        <div class="foot-code"><img :src="qrcode" width="100%"/></div>
        <ul class="foot-inner-ul">
          <li>
            <i class="foot-inner-icon email-icon"><img src="../../static/images/zmr-images/foot-email-icon.png" width="100%"/></i>
            <h3 class="foot-inner-txt">邮箱</h3>
            <p class="foot-inner-txt">{{email}}</p>
          </li>
          <li>
            <i class="foot-inner-icon phone-icon"><img src="../../static/images/zmr-images/foot-phone-icon.png" width="100%"/></i>
            <h3 class="foot-inner-txt">电话</h3>
            <p class="foot-inner-txt">{{mobile}}</p>
          </li>
        </ul>
        <ul class="foot-inner-ul">
          <li>
            <i class="foot-inner-icon url-icon"><img src="../../static/images/zmr-images/foot-url-icon.png" width="100%"/></i>
            <h3 class="foot-inner-txt">网址</h3>
            <p class="foot-inner-txt">{{web_url}}</p>
          </li>
          <li>
            <i class="foot-inner-icon address-icon"><img src="../../static/images/zmr-images/foot-address-icon.png" width="100%"/></i>
            <h3 class="foot-inner-txt">地址</h3>
            <p class="foot-inner-txt">{{address}}</p>
          </li>
        </ul>
      </div>
      <div class="foot-bottom">
        版权所有：黑龙江龙采科技集团有限责任公司 备案号：
        <a style="color:#fff;" href="http://beian.miit.gov.cn">黑ICP备19006357号-1</a>
      </div>
    </div>
  </div>
</template>

<script>
  import tool from '../assets/js/tool.js'
  export default {
    name: "footer-com",
    data () {
      return{
        address:'',//底部地址
        email:'',//底部邮箱
        mobile:'',//底部手机号
        web_url:'',//底部网址
        qrcode:'',//二维码图片
      }
    },
    methods:{
      getFooter () {
        let data = {};
        tool.postData('About/index', data,(res) => {//底部信息
          // console.log(22222,res.data.data.footer)
          let setting = res.data.data.footer;
          this.address = setting.address;
          this.email = setting.email;
          this.mobile = setting.mobile;
          this.web_url = setting.web_url;
          this.qrcode = setting.qrcode;
          },
        );
      },
    },
    mounted() {
      this.getFooter();
    }
  }
</script>

<style scoped>
  .footer{
    padding-top: 130px;
  }
  .foot{
    width: 100%;
    background-color: #303030;
    padding-top: 60px;
  }
  .foot-inner{
    position: relative;
    width: 1220px;
    margin: 0 auto 0;
  }
  .foot-code{
    width: 172px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .foot-inner-ul{
    display: flex;
    justify-content: space-between;
    text-align: center;
  }
  .foot-inner-ul li{
    width: 446px;
    margin-bottom: 50px;
  }
  .foot-inner-txt{
    color: #fff;
    font-size: 20px;
    line-height: 27px;
  }
  .foot-inner-icon{
    display: block;
    margin: 0 auto 10px;
  }
  .email-icon,.phone-icon{
    width: 23px;
  }
  .url-icon{
    width: 18px;
  }
  .address-icon{
    width: 16px;
  }
  .foot-bottom{
    width: 100%;
    background: #000;
    line-height: 53px;
    color: #fff;
    text-align: center;
    font-size: 14px;
  }
</style>



// WEBPACK FOOTER //
// src/components/foot.vue